import React from 'react';
import { BsInstagram, BsArrowLeftShort, BsArrowRightShort } from 'react-icons/bs';
import { SubHeading } from '../../../components/ClientPage';
import { SOCIAL_MEDIA } from '../../../constants/enums';
import { useTranslation } from 'react-i18next';
import './Gallery.css';

const Gallery = () => {
  const scrollRef = React.useRef(null);
  const { t } = useTranslation();
  const images = [
    '/assets/landscape1.png',
    '/assets/dish1.png',
    '/assets/dish2.png',
    '/assets/dish3.png'
  ];

  const navigateSocialMedia = (e) => {
    window.open(SOCIAL_MEDIA.INSTAGRAM, "_blank");
  };

  const scroll = (direction) => {
    const { current } = scrollRef;

    if (direction === 'left') {
      current.scrollLeft -= 300;
    } else {
      current.scrollLeft += 300;
    }
  };

  return (
    <div className="app__gallery flex__center">
      <div className="app__gallery-content">
        <SubHeading title="Instagram" />
        <h1 className="headtext__cormorant">{t('gallery_section.title')}</h1>
        <p className="p__opensans" style={{ color: '#AAAAAA', marginTop: '2rem' }}>{t('gallery_section.content')}</p>
        <button type="button" className="custom__button" onClick={navigateSocialMedia}>{t('gallery_section.view_more_btn')}</button>
      </div>
      <div className="app__gallery-images">
        <div className="app__gallery-images_container" ref={scrollRef}>
          {images.map((image, index) => (
            <div className="app__gallery-images_card flex__center" key={`gallery_image-${index + 1}`}>
              <img src={image} alt="gallery_image" />
              <BsInstagram className="gallery__image-icon" onClick={navigateSocialMedia}/>
            </div>
          ))}
        </div>
        <div className="app__gallery-images_arrows">
          <BsArrowLeftShort className="gallery__arrow-icon" onClick={() => scroll('left')} />
          <BsArrowRightShort className="gallery__arrow-icon" onClick={() => scroll('right')} />
        </div>
      </div>
    </div>
  );
};

export default Gallery;
